import { Divider, DividerProps, styled } from '@mui/material';

const VerticalDivider = styled((props: DividerProps) => <Divider {...props} orientation="vertical" />)(({ theme }) => ({
    height: 16,
}));

export default VerticalDivider;
